var _defs, _title, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgressIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    style: {},
    className: ""
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2388_677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.625,
    height: 35.625,
    fill: "white",
    y: 0,
    x: 18.9375,
    id: "svg_1"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8905999999999995,14.249990075762469 H8.906199999999998 C9.142499999999998,14.249990075762469 9.369,14.39771695617194 9.536000000000001,14.660884991528256 C9.703,14.923895535540854 9.7969,15.280613429066918 9.7969,15.652607982933837 V35.99119760229355 H0.8905999999999995 C0.6543999999999993,35.99119760229355 0.4279000000000012,35.84347072188408 0.2608999999999997,35.58030268652777 C0.0938000000000017,35.31729214251517 0,34.960574248989104 0,34.58857969512218 V15.652607982933837 C0,15.280613429066918 0.0938000000000017,14.923895535540854 0.2608999999999997,14.660884991528256 C0.4279000000000012,14.39771695617194 0.6543999999999993,14.249990075762469 0.8905999999999995,14.249990075762469 z",
    fill: "#808099",
    id: "svg_4",
    className: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.804699999999997,8.460889911689469 H21.820300000000003 C22.0565,8.460889911689469 22.283,8.592824287768394 22.4501,8.827467959815051 C22.6171,9.062111631861699 22.710900000000002,9.380496398842364 22.710900000000002,9.712369664335894 V35.99119638682529 H12.914100000000001 V9.712369664335894 C12.914100000000001,9.380496398842364 13.0079,9.062111631861699 13.174900000000001,8.827467959815051 C13.341900000000003,8.592824287768394 13.5685,8.460889911689469 13.804699999999997,8.460889911689469 z",
    fill: "#808099",
    id: "svg_5",
    className: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7187,-1.1491779045257366e-7 H34.7344 C34.9706,-1.1491779045257366e-7 35.1971,0.12038666278132759 35.3641,0.33465562709618973 C35.5312,0.5489245914110518 35.625,0.8395514096117981 35.625,1.1425838132809032 V34.84864933338602 C35.625,35.151668908114615 35.5312,35.44224441055334 35.3641,35.65648771698719 C35.1971,35.87073102342105 34.9706,35.991194774763194 34.7344,35.991194774763194 H25.8281 V1.1425838132809032 C25.8281,0.8395514096117981 25.921999999999997,0.5489245914110518 26.089,0.33465562709618973 C26.256,0.12038666278132759 26.4825,-1.1491779045257366e-7 26.7187,-1.1491779045257366e-7 z",
    fill: "#808099",
    id: "svg_6",
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIcon);
export default __webpack_public_path__ + "static/media/progress-icon.76ea1cd03f4fe2d5c9525c4f41dd3efd.svg";
export { ForwardRef as ReactComponent };